import { render, staticRenderFns } from "./SkeletonTile.vue?vue&type=template&id=96b1b85c&"
import script from "./SkeletonTile.vue?vue&type=script&lang=js&"
export * from "./SkeletonTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports